/**
 * Enum-like object representing the available theme options for the application.
 * The `Object.freeze` method is used to make the object immutable.
 *
 * @author Helmi Ben Eroi
 * @date 2024-08-16
 *
 * @type {Object}
 * @property {string} HORIZON - Represents the HORIZON theme.
 * @property {string} PULSE - Represents the PULSE theme. 
 * @property {string} ENUM_CODE - Represents the ENUM_CODE theme.
 */
export const themeEnums = Object.freeze({ 
  HORIZON: 'HORIZON',
  PULSE: 'PULSE',
  SHOPY:"SHOPY"
  });
  
export const keyTemplateSettings = Object.freeze({ 
  bannerHomePagefooter1:'BANNER_HOME_PAGE_FOOTER_1',
  bannerHomePageHeader1:'BANNER_HOME_PAGE_HEADER_1',
  logo:'LOGO', 
  address:'ADDRESS',
  links:'LINKS',
  socialNetworks:'SOCIAL_NETWORKS',
  newsletterSubscribeText:'NEWSLETTER_SUBSCRIBE_TEXT',
  homePageFooterTextMain:'HOME_PAGE_FOOTER_TEXT_MAIN',
    shopDescription: 'SHOP_DESCRIPTION'
});
  


/**
 * articleType
 */
  
export const articleType = Object.freeze({ 
  model:'MODEL', 
simple:'SIMPLE',
declination:'DECLINATION',
regroupement:'REGROUPEMENT'
});
   
export const fieldToModifyEnums = Object.freeze({
  LABEL: 'LABEL',
  CUSTOMER_NAME: 'CUSTOMER_NAME',
  DOCUMENT_REFERENCE: 'DOCUMENT_REFERENCE',
  NOTE: 'NOTE',
  NOTE_INTERNAL: 'NOTE_INTERNAL',
  DOCUMENT_WEB_ORIGIN: 'DOCUMENT_WEB_ORIGIN',
  DOCUMENT_WEB_TRACABILITY_CODE: 'DOCUMENT_WEB_TRACABILITY_CODE',
  DOCUMENT_WEB_NUMBER: 'DOCUMENT_WEB_NUMBER',
  CUSTOMER_INVOICING_NAME: 'CUSTOMER_INVOICING_NAME',
  CUSTOMER_INVOICING_ADDRESS1: 'CUSTOMER_INVOICING_ADDRESS1',
  CUSTOMER_INVOICING_ADDRESS2: 'CUSTOMER_INVOICING_ADDRESS2',
  CUSTOMER_INVOICING_ADDRESS3: 'CUSTOMER_INVOICING_ADDRESS3',
  CUSTOMER_INVOICING_POSTAL_CODE: 'CUSTOMER_INVOICING_POSTAL_CODE',
  CUSTOMER_INVOICING_CITY: 'CUSTOMER_INVOICING_CITY',
  CUSTOMER_INVOICING_COUNTRY_ID: 'CUSTOMER_INVOICING_COUNTRY_ID',
  CUSTOMER_DELIVERY_NAME: 'CUSTOMER_DELIVERY_NAME',
  CUSTOMER_DELIVERY_ADDRESS1: 'CUSTOMER_DELIVERY_ADDRESS1',
  CUSTOMER_DELIVERY_ADDRESS2: 'CUSTOMER_DELIVERY_ADDRESS2',
  CUSTOMER_DELIVERY_ADDRESS3: 'CUSTOMER_DELIVERY_ADDRESS3',
  CUSTOMER_DELIVERY_POSTAL_CODE: 'CUSTOMER_DELIVERY_POSTAL_CODE',
  CUSTOMER_DELIVERY_CITY: 'CUSTOMER_DELIVERY_CITY',
  CUSTOMER_DELIVERY_COUNTRY_ID: 'CUSTOMER_DELIVERY_COUNTRY_ID',
  CUSTOMER_PROVENANCE_ID: 'CUSTOMER_PROVENANCE_ID',
  PAYMENT_DEADLINE: 'PAYMENT_DEADLINE',
  CUSTOMER_PAYMENT_DEADLINE_ID: 'CUSTOMER_PAYMENT_DEADLINE_ID',
  CUSTOMER_PAYMENT_METHOD_ID: 'CUSTOMER_PAYMENT_METHOD_ID',
  CUSTOMER_VAT_NUMBER: 'CUSTOMER_VAT_NUMBER',
  DOCUMENT_VALIDITY: 'DOCUMENT_VALIDITY',
  DELIVERY_DATE: 'DELIVERY_DATE',
  DELIVERY_TIME: 'DELIVERY_TIME',
  DELIVERY_IN_STORE: 'DELIVERY_IN_STORE',
});
